module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"title":"Dine mål","braindateTitle":"Great Job, {name}","braindateSubtitle":"You have completed your daily goal","dailyTab":"Daglig","weeklyTab":"Ukentlig","lifelongTab":"Livslang"},"en":{"title":"Your Goals","braindateTitle":"Great Job, {name}","braindateSubtitle":"You have completed your daily goal","dailyTab":"Daily","weeklyTab":"Weekly","lifelongTab":"Lifelong"}}')
  delete Component.options._Ctor
}
